import React, { useEffect, useState } from 'react';
import api from '../services/api';
import logo from '../assets/FCI Logo - Cropped.png';
import '../css/requisition-app-styles.css';
import { Link } from 'react-router-dom';
import userIcon from '../img/User-Icon.png';
import TopBarIcons from './TopBarIcons';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import "../css/Requisitions.css";
import '../css/Pagination.css';
import '../css/Notifications.css';
import Sidebar from './Sidebar';



const Notifications = () => {
  console.log("=== NOTIFICATIONS COMPONENT RENDERED ===");
  console.log("User ID from localStorage:", localStorage.getItem('userId'));
  console.log("Environment variables:");
  console.log("REACT_APP_API_BASE_URL:", process.env.REACT_APP_API_BASE_URL);
  console.log("REACT_APP_STATIC_BASE_URL:", process.env.REACT_APP_STATIC_BASE_URL);

  const navigate = useNavigate();
  const theUserType = localStorage.getItem('userType');

 
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const theUserId = localStorage.getItem('userId');  

  // Tab state
  const [activeTab, setActiveTab] = useState('all'); // 'all', 'read', 'unread'

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        console.log("=== STARTING NOTIFICATION FETCH ===");
      console.log("User ID:", theUserId);
      console.log("API URL:", `${process.env.REACT_APP_API_BASE_URL}/notifications/user/${theUserId}`);
        const userId = theUserId;  
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/notifications/user/${userId}`);
  
        if (response.ok) {
          const data = await response.json();
          const notifications = Array.isArray(data) ? data : [];

          if (notifications.length > 0) {
            console.log("=== NOTIFICATION DEBUG INFO ===");
            console.log("First notification object:", notifications[0]);
            console.log("All properties:", Object.keys(notifications[0]));
            console.log("requesterDisplayPicturePath:", notifications[0].requesterDisplayPicturePath);
            console.log("reviewerDisplayPicturePath:", notifications[0].reviewerDisplayPicturePath);
            console.log("Full URL that would be generated:", 
              `${process.env.REACT_APP_STATIC_BASE_URL}${notifications[0].requesterDisplayPicturePath}`);
            console.log("=== END DEBUG ===");
          }
  
          setNotifications(notifications);
          setUnreadCount(notifications.filter(n => !n.isRead).length);
        } else {
          console.error('Failed to fetch notifications');
        }
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    };
  
    fetchNotifications();
  }, [theUserId]);
    

  const handleNotificationClick = async (notification) => {
    const requisitionId = notification.requisitionID;
    const notificationType = notification.type;

  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/notifications/mark-as-read/${notification.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      if (response.ok) {
        setNotifications(prevNotifications =>
          prevNotifications.map(n =>
            n.id === notification.id ? { ...n, isRead: true } : n
          )
        );
  
        setUnreadCount(prevUnreadCount => prevUnreadCount - 1);
      } else {
        console.error('Failed to mark notification as read, status code:', response.status);
      }
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
    console.log("Navigating to requisition ID:", requisitionId);

    

    if (requisitionId) {
      const cleanActionLink = notification.actionLink.replace(/,+$/, ''); 
      console.log('The Cleaned ActionLink:', cleanActionLink);
      if(notificationType !== "Reviewed")
        navigate(cleanActionLink);

    }
  };

  // Filter notifications based on active tab
  const getFilteredNotifications = () => {
    switch (activeTab) {
      case 'read':
        return notifications.filter(n => n.isRead === true);
      case 'unread':
        return notifications.filter(n => n.isRead === false);
      case 'all':
      default:
        return notifications;
    }
  };

  /*------------------- Pagination  ------------------------*/

  const [currentPage, setCurrentPage] = useState(1);
  const notificationsPerPage = 10;

  const filteredNotifications = getFilteredNotifications();
  const totalFilteredNotifications = filteredNotifications.length;

  const indexOfLastNotification = currentPage * notificationsPerPage;
  const indexOfFirstNotification = indexOfLastNotification - notificationsPerPage;
  const currentNotifications = filteredNotifications.slice(indexOfFirstNotification, indexOfLastNotification);

  const totalPages = Math.ceil(totalFilteredNotifications / notificationsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Reset to page 1 when tab changes
  useEffect(() => {
    setCurrentPage(1);
  }, [activeTab]);

  // Get counts for each tab
  const unreadCountValue = notifications.filter(n => n.isRead === false).length;

  /*-------------------------------------------------------------*/


      
    return (
        <div id="wrapper">
          
          <Sidebar userType={theUserType} />


{/* Content Wrapper */} 

<div id="content-wrapper" className="d-flex flex-column">

    {/* Main Content */}
    <div id="content">



    {/* Topbar */}
    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

    {/* Sidebar Toggle */}
    <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
        <i className="fa fa-bars"></i>
    </button>

    {/* Topbar Search */}
    <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
        <div className="input-group">
            <input type="text" className="form-control bg-light border-0 small" placeholder="Search"
                aria-label="Search" aria-describedby="basic-addon2" />
            <div className="input-group-append">
                <button className="btn btn-primary" type="button">
                    <i className="fas fa-search fa-sm"></i>
                </button>
            </div>
        </div>
    </form>

    {/* Topbar Navbar */}
    <ul className="navbar-nav ml-auto">

        <TopBarIcons />
        
        

    </ul>

    </nav>
    {/* End of Topbar */}






        {/* Begin Page Content */}
        <div className="container-fluid">

            <h1 className="h3">Notifications</h1>
            <br/>

            {/* Tabs - Same style as StaffRequisitions */}
            <div className="tabs">
              <button
                className={`nav-link ${activeTab === 'all' ? 'active' : ''}`}
                onClick={() => setActiveTab('all')}
              >
                All 
              </button>
              <button
                className={`nav-link ${activeTab === 'read' ? 'active' : ''}`}
                onClick={() => setActiveTab('read')}
              >
                Read 
              </button>
              <button
                className={`nav-link ${activeTab === 'unread' ? 'active' : ''}`}
                onClick={() => setActiveTab('unread')}
              >
                Unread
                {unreadCountValue > 0 && <span className="tab-count">{unreadCountValue}</span>}
              </button>

            </div>

           
            <div id="notifications-container">
            {currentNotifications.length > 0 ? (
              currentNotifications.map((notification, index) => (
              <div key={index}>
              <div className="dropdown-divider"></div>
              <a
                className={`dropdown-item d-flex align-items-center ${!notification.isRead ? 'bg-warning' : ''}`} 
                onClick={() => {
                  handleNotificationClick(notification);
                }}
                style={{ cursor: "pointer" }}
              >
                {notification.type === 'info-notification' && (
                  <div className="dropdown-list-image mr-3">
                  <img className="img-profile rounded-circle resize-image" src={`${process.env.REACT_APP_STATIC_BASE_URL}/${notification.requesterDisplayPicturePath}`} alt="User Icon" />
                </div>
                )}
                
                {notification.type === 'reviewer-to-reviewer' && (
                  <div className="dropdown-list-image mr-3">
                  <img className="img-profile rounded-circle resize-image" src={`${process.env.REACT_APP_STATIC_BASE_URL}/${notification.reviewerDisplayPicturePath}`}  alt="User Icon" />
                </div>
                )}
                {notification.type === 'Reviewed' && (
                  <div className="dropdown-list-image mr-3">
                  <img className="img-profile rounded-circle resize-image" src={`${process.env.REACT_APP_STATIC_BASE_URL}/${notification.reviewerDisplayPicturePath}`}  alt="User Icon" />
                </div>
                )}
                {notification.type === 'disbursed' && (
                  <div className="dropdown-list-image mr-3">
                  <img className="img-profile rounded-circle resize-image" src={`${process.env.REACT_APP_STATIC_BASE_URL}/icons/dollar-sign-icon.jpg`} alt="User Icon" />
                </div>
                )}
                {notification.type === 'surrender-process-complete' && (
                  <div className="dropdown-list-image mr-3">
                  <img className="img-profile rounded-circle resize-image" src={`${process.env.REACT_APP_STATIC_BASE_URL}/icons/tick.png`} alt="User Icon" />
                </div>
                )}
                {notification.type === 'disburse' && (
                  <div className="dropdown-list-image mr-3">
                  <img className="img-profile rounded-circle resize-image" src={`${process.env.REACT_APP_STATIC_BASE_URL}/icons/hand-holding-money.jpg`} alt="User Icon" />
                </div>
                )}
                {notification.type === 'disapproved' && (
                  <div className="dropdown-list-image mr-3">
                  <img className="img-profile rounded-circle resize-image" src={`${process.env.REACT_APP_STATIC_BASE_URL}/icons/x-icon.jpg`} alt="User Icon" />
                </div>
                )}
                <div className="font-weight-bold">
                  <div className="text-truncate">{notification.title}</div>
                  <div className="small text-gray-500">{notification.message}</div>
                </div>
              </a>
            </div>
            ))
            ) : (
              <div className="no-notifications-message">
                <p>No notifications to display</p>
              </div>
            )}

          <div className="dropdown-divider"></div>
          
          <br/>

          {/* Pagination - Only show if there are notifications */}
          {totalFilteredNotifications > 0 && (
            <div className="pagination-container">
              <div className="page-numbers-text">Page Numbers: </div>
              <div className="pagination-scroll-wrapper">
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    className={`pagination-button ${currentPage === index + 1 ? 'active' : ''}`}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </button>
                ))}
              </div>
            </div>
          )}
                
          <br/>
          </div>
          <br/><br/><br/><br/>




        </div>
        {/* End of container-fluid */}

    </div>
    {/* End of Main Content */}

    {/* Footer */}
    <footer className="sticky-footer bg-white">
        <div className="container my-auto">
            <div className="copyright text-center my-auto">
                <span>Copyright &copy; Farm Concern International 2025 </span>
            </div>
        </div>
    </footer>
    {/* End of Footer */}

</div>


    
    {/* End of Content Wrapper */}


           
          
          
        </div>

  );
   
};

export default Notifications;